import keyBy from 'lodash/keyBy';
import { practice as defaultState } from './default.json';
import { actionTypes } from '../actions/practice';

const handlers = {
  [actionTypes.CLEAR_WATCHING]: state => ({
    ...state,
    watching: {
      ...defaultState.watching,
    },
  }),
  [actionTypes.CURRENT_PRACTICE_SET]: (state, action) => ({
    ...state,
    watching: {
      currentPractice: state.slugs[action.practiceSlug],
    },
  }),
  [actionTypes.PRACTICE_GET_ERROR]: (state, action) => ({
    ...state,
    inProgress: false,
    error: action.error,
  }),
  [actionTypes.PRACTICE_GET_IN_PROGRESS]: state => ({
    ...state,
    inProgress: true,
  }),
  [actionTypes.PRACTICE_GET_SUCCESS]: (state, action) => ({
    ...state,
    inProgress: false,
    results: {
      ...action.results.items,
    },
    meta: action.results.meta,
    slugs: keyBy(action.results.items, 'slug'),
  }),
};

export default (state = defaultState, action) => {
  const handler = handlers[action.type];
  return handler ? handler(state, action) : state;
};
